var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',{attrs:{"top":_vm.scrollTop}}),_c('div',{staticClass:"container"},[_c('router-view',{key:_vm.key})],1),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }